import { render, staticRenderFns } from "./Page08.vue?vue&type=template&id=6e39fda4&scoped=true&"
import script from "./Page08.vue?vue&type=script&lang=js&"
export * from "./Page08.vue?vue&type=script&lang=js&"
import style0 from "./Page08.vue?vue&type=style&index=0&id=6e39fda4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e39fda4",
  null
  
)

export default component.exports